import { render, staticRenderFns } from "./customHomePage.vue?vue&type=template&id=3c8916fd&scoped=true&"
import script from "./customHomePage.vue?vue&type=script&lang=js&"
export * from "./customHomePage.vue?vue&type=script&lang=js&"
import style0 from "./customHomePage.vue?vue&type=style&index=0&id=3c8916fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8916fd",
  null
  
)

export default component.exports